<template>
  <div v-if="vf_login" style="z-index: 999; position: fixed; top: -66px; width: 100%; height: 120%; background-color: rgba(0, 0, 0, 0.6)">
    <div style="width: 420px; height: 457px; background-color: #fff; position: fixed; top: 20%; left: 37%; border-radius: 12px">
      <div @click="shutdown()" style="position: absolute; top: 8px; right: 16px; color: #888888; font-size: 20px; cursor: pointer">✖</div>
      <div v-show="denglu">
        <div class="denglu">
          <span @click="zhLogin" :class="pswdLogin ? classA : classB" style="background-color: #fff">账号登录</span>
          <span @click="sjLogin" :class="codeLogin ? classA : classB" style="margin-left: 40px; background-color: #fff">手机登录</span>
        </div>
        <div class="xiahuaxian">
          <div :class="pswdLogin ? classC : classB"></div>
          <div :class="codeLogin ? classC : classB" style="margin-left: 85px"></div>
        </div>
      </div>
      <div v-show="fgtps" class="fogetpsd">
        <span>忘记密码</span>
      </div>
      <div v-show="zhuche" class="fogetpsd">
        <span>注册账号</span>
      </div>

      <!-- 密码登录 -->
      <div v-show="pswdLogin" style="margin-top: 45px; margin-left: 60px; position: relative"  v-focus>
        <div class="shuru">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <img style="width: 16px; height: 16px; position: absolute; top: 4px" src="./images/ico_zhanghao@2x.png" alt="" />
            <input v-model="phone" style="margin-left: 28px" type="text" placeholder="请输入用户名" autocomplete="off"/>
          </div>
        </div>
        <div class="shuru" style="margin-top: 20px">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <img style="width: 16px; height: 16px; position: absolute; top: 4px" src="./images/ico_mima@2x.png" alt="" />
            <input v-model="password" style="margin-left: 28px" :type="passwordType" placeholder="请输入密码" ref="password" autocomplete="off"/>
            <span @click="showPassword">
              <i class="iconfont icon-no_eye" v-if="passwordType=='password'"></i>
              <i class="iconfont icon-eye " v-else></i>
            </span>
          </div>
        </div>

        <div style="font-size: 14px; color: #808695; margin-top: 16px; line-height: 20px; width: 300px">
          <!-- <input type="checkbox" name="vehicle" style="float: left; width: 14px; height: 14px" /> -->
          <!-- <span style="float: left; margin-left: 6px">下次自动登录</span> -->
          <div class="remember">
            <el-checkbox v-model="isRemember"></el-checkbox>
            <span>记住密码</span>
          </div>
          <span @click="v_fgtps()" style="float: right; color: #1872ed; cursor: pointer">忘记密码?</span>
        </div>
        <button @click="pswd_login()" @keydown="keyDownLogin()" style="margin-top: 60px; border: none; border-radius: 4px; width: 300px; height: 40px; color: #fff; background: #1872ED; font-size: 16px">
          <span style="display: block; font-size: 18px; color: #fff">登录</span>
        </button>

        <div style="margin-top: 16px; height: 20px">
          <p style="color: #212224; font-size: 14px; margin-left: 15px; display: inline-table; -webkit-margin-before: 0; -webkit-margin-after: 0">
            登录后可观看课程内容 没有账号?
            <a href="url" style="color: #1872ED; font-size: 14px; text-decoration: none" @click.prevent="v_zhuce()">立即注册</a>
          </p>
        </div>
      </div>

      <!-- 手机登录 -->
      <div v-show="codeLogin" style="margin-top: 45px; margin-left: 60px; position: relative">
        <div class="shuru">
          <div style="" class="login-phone">
            <span class="login-phone-icon">+</span>
            <el-select v-model="area" placeholder="请选择"  style="z-index:999999">
              <el-option v-for="item in areaCodeList" :key="item.numcode" :label="item.phonecode" :value="item.phonecode">
                <span style="float: left">{{ item.nameZh }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.phonecode }}</span>
              </el-option>
            </el-select>
            <input v-model="phone" type="text" placeholder="请输入您的手机号" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off"/>
          </div>
        </div>
        <div class="shuru" style="margin-top: 20px">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <input v-model="code" style="margin-left: 1px; width: 170px; position: absolute; left: 1px" type="text" placeholder="请输入验证码" autocomplete="off"/>
            <button v-if="phone_text == '获取验证码'" @click="sendMsg2(area, phone)" class="content-box_code_buttom">
              {{ phone_text }}
            </button>
            <button v-else class="content-box_code_buttom" style="background-color: #fff; color: #afafaf">
              {{ phone_text }}
            </button>
          </div>
        </div>
        <div style="font-size: 14px; color: #808695; margin-top: 16px; line-height: 20px; width: 300px">
          <!-- <input type="checkbox" name="vehicle" style="float: left; width: 14px; height: 14px" /> -->
          <!-- <span style="float: left; margin-left: 6px">下次自动登录</span> -->
          <span @click="v_fgtps()" style="float: right; color: #1872ED; cursor: pointer">忘记密码?</span>
        </div>

        <button @click="login" style="margin-top: 60px; border: none; border-radius: 4px; width: 300px; height: 40px; color: #fff; background: #1872ED; font-size: 16px">
          <span style="display: block; font-size: 18px; color: #fff">登录</span>
        </button>

        <div style="margin-top: 16px; height: 20px">
          <p style="color: #212224; font-size: 14px; margin-left: 15px; display: inline-table; -webkit-margin-before: 0; -webkit-margin-after: 0">
            登录后可观看课程内容 没有账号?
            <a href="url" style="color: #1872ED; font-size: 14px; text-decoration: none" @click.prevent="v_zhuce()">立即注册</a>
          </p>
        </div>
      </div>

      <!-- 注册账号 -->
      <div v-if="vzhuce" style="margin-top: 45px; margin-left: 60px; position: relative">
        <div class="shuru">
          <div class="login-phone">
            <span class="login-phone-icon">+</span>
            <el-select v-model="area" placeholder="请选择">
              <el-option v-for="item in areaCodeList" :key="item.numcode" :label="item.phonecode" :value="item.phonecode">
                <span style="float: left">{{ item.nameZh }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.phonecode }}</span>
              </el-option>
            </el-select>
            <input v-model="phone" type="text" placeholder="请输入您的手机号" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off"/>
          </div>
        </div>

        <div class="shuru" style="margin-top: 20px">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <input v-model="code" style="margin-left: 1px; width: 170px; position: absolute; left: 1px" type="text" placeholder="请输入验证码" autocomplete="off"/>
            <button v-if="phone_text == '获取验证码'" @click="sendMsg2(area, phone)" class="content-box_code_buttom">
              {{ phone_text }}
            </button>
            <button v-else class="content-box_code_buttom" style="background-color: #fff; color: #afafaf">
              {{ phone_text }}
            </button>
          </div>
        </div>

        <div class="shuru" style="margin-top: 20px">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <input v-model="password" style="width: 250px" :type="passwordType" placeholder="设置6-15位  数字、字母密码" ref="password" autocomplete="off"/>
            <span @click="showPassword">
              <i class="iconfont icon-no_eye" v-if="passwordType=='password'"></i>
              <i class="iconfont icon-eye " v-else></i>
             </span>
          </div>
        </div>

        <button @click="register()" style="margin-top: 50px; border: none; border-radius: 4px; width: 300px; height: 40px; color: #fff; background:#1872ED; font-size: 16px">
          <span style="display: block; font-size: 18px; color: #fff">注册</span>
        </button>

        <div style="margin-top: 16px; height: 20px">
          <p style="color: #212224; font-size: 14px; margin-left: 85px; display: inline-table; -webkit-margin-before: 0; -webkit-margin-after: 0">
            已有账号？
            <a href="url" style="color: #1872ED; font-size: 14px; text-decoration: none" @click.prevent="v_login()">请登录</a>
          </p>
        </div>
      </div>

      <!-- 忘记密码 -->
      <div v-if="vfgtps" style="margin-top: 45px; margin-left: 60px; position: relative">
        <div class="shuru">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <span style="width: 32px; font-size: 14px; color: #202020; border-right: 1px solid #dfe1e5; padding-right: 14px">+{{ area }}</span>
            <input v-model="phone" style="margin-left: 10px" type="text" placeholder="请输入您的手机号" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off"/>
          </div>
        </div>

        <div class="shuru" style="margin-top: 20px">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <input v-model="code" style="margin-left: 1px; width: 170px; position: absolute; left: 1px" type="text" placeholder="请输入验证码" />
            <button v-if="phone_text == '获取验证码'" @click="sendMsg(area, phone)" class="content-box_code_buttom">
              {{ phone_text }}
            </button>
            <button v-else class="content-box_code_buttom" style="background-color: #fff; color: #afafaf">
              {{ phone_text }}
            </button>
          </div>
        </div>

        <div class="shuru" style="margin-top: 20px">
          <div style="position: absolute; margin-top: 10px; margin-left: 16px">
            <input v-model="password" style="width: 250px" :type="passwordType" placeholder="请输入新密码" ref="password" autocomplete="off"/>
            <span @click="showPassword">
              <i class="iconfont icon-no_eye" v-if="passwordType=='password'"></i>
              <i class="iconfont icon-eye " v-else></i>
             </span>
          </div>
        </div>

        <button @click="change_Pswd()" style="margin-top: 50px; border: none; border-radius: 4px; width: 300px; height: 40px; color: #fff; background: #1872ED; font-size: 16px">
          <span style="display: block; font-size: 18px; color: #fff">登录</span>
        </button>

        <div style="margin-top: 16px; height: 20px">
          <p style="color: #212224; font-size: 14px; display: inline-table; -webkit-margin-before: 0; -webkit-margin-after: 0">
            <a href="url" style="color: #1872ED; font-size: 14px; text-decoration: none" @click.prevent="v_login()">返回登录</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sendMessage from '../mixins/sendMessage'
import { mapState } from 'vuex'
import { Base64 } from "js-base64"
import Cookies from "js-cookie"
import CryptoJS from 'crypto-js'

export default {
  props: [''],
  mixins: [sendMessage],
  data () {
    return {
      vf_login: false,
      denglu: true,
      zhuche: false,
      fgtps: false,
      pswdLogin: true,
      codeLogin: false,
      vzhuce: false,
      vfgtps: false,
      classA: 'xuanzhong',
      classC: 'xuanzhongX',
      classB: '',
      phone_text: '获取验证码',
      area: '86',
      phone: '',
      password: '',
      code: '',
      token: '',
      uid: '',
      domain: 'www.tengface.com',
      areaCodeList: [],
      passwordType: 'password',
      isRemember:false
    }
  },
  created () {
    this.getAreaCode()
  },
  mounted(){
    this.queryLocalForm()
  },
  computed: {
    ...mapState(['org_id'])
  },
  methods: {
    showPassword() {
            this.passwordType = this.passwordType === 'password' ? '' : 'password'
            this.$nextTick(() => {
                this.$refs.password.focus()
            })
        },
    keyDownLogin () {
      console.log(123)
    },
    // 关闭登录页面
    shutdown () {
      this.vf_login = false
      this.pswdLogin = true
      this.vzhuce = false
      this.vfgtps = false
      this.codeLogin = false
      this.denglu = true
      this.fgtps = false
      this.zhuche = false
    },
    open () {
      this.vf_login = true
      this.code = ''
      if(!this.isRemember){
        this.phone = ''
        this.password = ''
      }
    },
    zhLogin () {
      this.pswdLogin = true
      this.codeLogin = false
    },
    sjLogin () {
      this.pswdLogin = false
      this.codeLogin = true
    },
    v_zhuce () {
       this.passwordType='password'
      this.vzhuce = true
      this.vfgtps = false
      this.pswdLogin = false
      this.codeLogin = false
      this.zhuche = true
      this.denglu = false
      this.fgtps = false
    },
    v_fgtps () {
      this.passwordType='password'
      this.vfgtps = true
      this.vzhuce = false
      this.pswdLogin = false
      this.codeLogin = false
      this.fgtps = true
      this.denglu = false
      this.zhuche = false
    },
    v_login () {
      this.passwordType='password'
      this.pswdLogin = true
      this.vzhuce = false
      this.vfgtps = false
      this.codeLogin = false
      this.denglu = true
      this.fgtps = false
      this.zhuche = false
    },
    // 获取地区码
    async getAreaCode () {
      const res = await this.$axios.get('/common/index/areaCodes')
      const { data } = res
      if (data.code === 200) {
        this.areaCodeList = data.data
      }
    },
    // 验证码登录接口
    login () {
      // 验证手机号格式
      const phoneReg = /^1\d{10}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      if (!this.code) {
        this.$message.error("请输入正确的验证码");
        return;
      }
      var data = {
        area: this.area,
        phone: this.phone,
        code: this.code,
        org_id: this.org_id
      }
      this.$axios
        .post('/user/index/phoneLogin', data)
        .then(res => {
          if (res.data.code === 200) {
            this.shutdown()
            localStorage.setItem('token', res.data.data.token)
            this.$emit('updateLoginState')
            location.reload()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    },
    queryLocalForm () {
      const localForm = Cookies.get("LOCAL_KEY")
      if (localForm) {
        this.isRemember = true
        try {
          const { username, password } = JSON.parse(localForm)
          this.phone = Base64.decode(username)
          this.password = Base64.decode(password)
        } catch (error) {
          console.error("本地数据解析失败~", error)
        }
      } else {
        this.isRemember = false
      }
    },

    // 密码登录接口
    pswd_login () {
      // const data = {
      //   account: this.phone,
      //   password: this.password,
      //   org_id: this.org_id
      // }
      const isProd = process.env.NODE_ENV === 'production'
      // const isProd = true
      let url = ''
      let data = {}
      if(isProd) {
        url = '/user/index/loginHash'
        data = {
          account_hash: CryptoJS.SHA256(`${this.phone}:tengface_salt`).toString(),
          password_hash: CryptoJS.MD5(`Tengface@${this.password}`).toString(),
          org_id: this.org_id
        }
      } else {
        url = '/user/index/login'
        data = {
          account: this.phone,
          password: this.password,
          org_id: this.org_id
        }
      }
      // const data = {
      //   account_hash: CryptoJS.SHA256(`${this.phone}:tengface_salt`).toString(),
      //   password_hash: CryptoJS.MD5(`Tengface@${this.password}`).toString(),
      //   org_id: this.org_id
      // }
      this.$axios
        .post(url, data)
        .then(res => {
          if (res.data.code === 200) {
            // 检测是否需要记住密码
            if (this.isRemember) {
              const localForm = {
                username: Base64.encode(this.phone),
                password: Base64.encode(this.password)
              }
                Cookies.set("LOCAL_KEY", JSON.stringify(localForm))
              } else {
                Cookies.remove("LOCAL_KEY")
              }
            this.shutdown()
            localStorage.setItem('token', res.data.data.token)
            this.$emit('updateLoginState')
            location.reload()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    },

    // 注册接口
    register () {
      // const regTel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!this.phone) {
        this.$message({
          message: '请填写手机号码',
          type: 'error'
        })
        return
      }
      // 验证手机号格式
      const phoneReg = /^1\d{10}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      if (!this.code) {
        this.$message.error("请输入正确的验证码");
        return;
      }
      const data = {
        area: this.area,
        phone: this.phone,
        password: this.password,
        code: this.code,
        org_id: this.org_id
      }
      this.$axios
        .post('/user/index/phoneLogin', data)
        .then(res => {
          if (res.data.code === 200) {
            this.vf_login = false
            localStorage.setItem('token', res.data.data.token)
            this.$emit('updateLoginState')
            this.$message({
              message: '注册成功!',
              type: 'success'
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
        .catch(function (res) {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    },

    // 修改密码
    change_Pswd () {
      // 验证手机号格式
      const phoneReg = /^1\d{10}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      if (!this.code) {
        this.$message.error("请输入正确的验证码");
        return;
      }
      var self = this
      var data = {
        phone: this.phone,
        password: this.password,
        code: this.code,
        area: this.area,
        org_id: this.org_id
      }
      this.$axios
        .post('/user/index/updatePwd', data)
        .then(function (res) {
          if (res.data.code === 200) {
            self.$message({
              message: '修改成功!',
              type: 'success'
            })
            self.v_login()
          } else {
            self.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
        .catch(function (res) {
          self.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    }
  }
}
</script>
<style scoped>
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
.svg-icon {
  vertical-align: -0.35em;
}
.denglu {
  width: 210px;
  margin-top: 50px;
  margin-left: 105px;
  cursor: pointer;
}
.fogetpsd {
  width: 80px;
  margin-top: 50px;
  margin-left: 170px;
  font-size: 20px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  color: #202020;
}
.xiahuaxian {
  width: 210px;
  margin-top: 7px;
  margin-left: 125px;
}
.xiahuaxian div {
  float: left;
  width: 40px;
  height: 4px;
  background-color: #fff;
}
.denglu span {
  width: 80px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: right;
  color: #202020;
  line-height: 28px;
}
.xuanzhong {
  color: #1872ED !important;
}
.xuanzhongX {
  background-color: #1872ED !important;
}

.shuru {
  width: 300px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #dfe1e5;
  border-radius: 4px;
}
.shuru input {
  border: none;
  height: 20px;
  width: 220px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #202020;
  line-height: 20px;
  outline: none;
}

.content-box_code_buttom {
  height: 32px;
  width: 90px;
  background-color: #fff;
  color: #1872ED;
  font-size: 14px;
  border: none;
  position: absolute;
  left: 190px;
  top: -6px;
  cursor: pointer;
}
.login-phone {
  position: absolute;
  padding-top: 10px;
  padding-left: 70px;
}
.login-phone input {
  margin: 0;
}
.login-phone-icon {
  position: absolute;
  left: 4px;
  font-size: 14px;
  top: 11px;
  color: rgb(117, 117, 117);
}
.login-phone-icon::after {
  height: 20px;
  width: 1px;
  display: block;
  content: '';
  background: #dfe1e5;
  position: absolute;
  left: 64px;
  top: 1px;
}
.login-phone >>> .el-select {
  position: absolute;
  left: 18px;
  top: 3px;
}
.login-phone >>> .el-input__inner {
  border: none;
  background-color: transparent;
  width: 35px;
  padding: 0;
}
.login-phone >>> .el-select__caret {
  color: #1872ED !important;
  position: absolute;
  left: -5px;
  top: 0;
}
.remember{
  float: left;
}
.remember >>> .el-checkbox {
  margin-right: 10px;
}
</style>
